export default __webpack_public_path__ + "static/media/slider1.61d0b84b.jpg";